import { sanitizeHtml, isHtmlContent } from '../../utils/sanitize'

interface SafeHtmlContentProps {
  content: string
  className?: string
}

/**
 * Safely renders HTML content after sanitization.
 * Falls back to plain text rendering if the content doesn't contain HTML.
 */
export default function SafeHtmlContent({ content, className = '' }: SafeHtmlContentProps) {
  if (!content) {
    return null
  }

  // If content contains HTML, sanitize and render it
  if (isHtmlContent(content)) {
    const sanitized = sanitizeHtml(content)
    return (
      <div
        className={`prose prose-sm max-w-none ${className}`}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    )
  }

  // Plain text fallback - render with line breaks preserved
  return (
    <p className={className} style={{ whiteSpace: 'pre-wrap' }}>
      {content}
    </p>
  )
}
